import Component from "vue-class-component";
import Vue from "vue";
import { Prop, Watch } from "vue-property-decorator";

@Component({})
export default class ShowContainer extends Vue {
  loading: boolean = true;
  @Prop({ default: null }) idToFetch!: number;

  async created() {
    await this.onCreated();
  }

  async onCreated(): Promise<void> {
    this.loading = true;
    await this.fetch(this.id);
    this.loading = false;
  }

  get id(): number {
    return this.idToFetch ? this.idToFetch : Number(this.$route?.params?.id);
  }

  async fetch(id: number): Promise<void> {
    throw new NotImplementedError();
  }

  @Watch("idToFetch")
  async handler(): Promise<void> {
    await this.onCreated();
  }
}
